import React, {useMemo} from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon, IconName} from '@vio/atlas/Icon'
import {Tag, TagSize} from '@vio/atlas/src/components/designSystem/Tag'
import {cssTheme} from '@vio/atlas/src/themes'

import {getTopRoomAmenities} from './utils'

import type {Room} from '@vio/core/src/room/types/room'

interface Props {
  amenitiesList: Room['amenitiesList']
  /** `xs` renders compact tags without icons. */
  size?: TagSize
}

const StyledTag = styled(Tag)`
  border: ${cssTheme.layout.borderWidth.bw100} solid
    ${cssTheme.colors.border.neutral.secondary};
  background-color: ${cssTheme.colors.background.neutral.primary} !important;
`
const AmenityTag = ({
  iconName,
  amenity,
  size = 'md'
}: {
  iconName: IconName
  amenity: string
  size?: TagSize
}) => {
  return (
    <StyledTag
      variant="neutral"
      size={size}
      iconStart={
        size === 'xs' ? undefined : <Icon name={iconName} size={size} />
      }
    >
      {amenity}
    </StyledTag>
  )
}

export const RankedTopRoomAmenities = ({amenitiesList, size = 'md'}: Props) => {
  const topRankedAmenities = useMemo(
    () => getTopRoomAmenities(amenitiesList || []),
    [amenitiesList]
  )
  if (!topRankedAmenities?.length) return null
  return (
    <Box display="flex" flexDirection="row" gap="s250" flexWrap="wrap">
      {topRankedAmenities.map(amenity => (
        <AmenityTag
          key={amenity.id}
          iconName={amenity.icon}
          amenity={amenity.title}
          size={size}
        />
      ))}
    </Box>
  )
}
